<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>

      <span class="child">/ Change Proctor Duty</span> </v-row
    ><br />
    <v-card>
      <v-card-title class="justify-center heading">
        <h4>Change Proctor Duty</h4>
      </v-card-title>
      <v-overlay :value="loader" absolute>
        Loading
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="box">
        <v-row>
          <v-col xs="12" sm="12" lg="3" md="6" cols="12">
            <label class="bold">Exam</label>
            <v-autocomplete
              :items="exam_list"
              item-value="id"
              item-text="exam"
              v-model="exam"
              @change="findDates()"
              :rules="[(v) => !!v || 'required']"
              outlined
              dense
              placeholder="Select Exam"
              class="select"
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" lg="3" md="6" cols="12">
            <label class="bold">Exam Date</label>
            <v-select
              :items="dates"
              outlined
              dense
              placeholder="Select Exam Date"
              @change="findSlot()"
              v-model="date"
              :rules="[(v) => !!v || 'required']"
              class="select"
            ></v-select>
          </v-col>
          <v-col xs="12" sm="12" lg="2" md="6" cols="12">
            <label class="bold">Slot No </label>
            <v-select
              :items="slot_list"
              item-value="id"
              item-text="slotNo"
              outlined
              dense
              @change="findtime()"
              placeholder="Select Slot"
              v-model="slotNo"
              :rules="[(v) => !!v || 'required']"
              class="select"
            ></v-select>
          </v-col>
          <v-col xs="12" sm="12" lg="2" md="6" cols="12">
            <label class="bold">Start Time </label>
            <v-text-field
              readonly
              v-model="startTime"
              outlined
              dense
              class="select"
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" lg="2" md="6" cols="12">
            <label class="bold">End Time</label>
            <v-text-field
              readonly
              v-model="endTime"
              outlined
              dense
              class="select"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <v-btn class="mb-2 button btn" @click="fetchdetails()">Fetch</v-btn>
        </v-card-actions>
      </div>

                          <v-simple-table class="mytable" v-if="proctor_list.length > 0">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Sr.No.
                                    </th>
                                    <th class="text-left">
                                        Proctor Code
                                    </th>
                                    <th class="text-left">
                                        Proctor Name
                                    </th>
                                    <th class="text-left">
                                        Proctor Contact No.
                                    </th>
                                    <th class="text-left">
                                        Student Count
                                    </th>
                                    <th class="text-left">
                                        Change Proctor
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in proctor_list" :key="item.proctor_id">
                                    <td>{{ item.srno }}</td>
                                    <td>{{ item.proctor_code }}</td>
                                    <td>{{ item.proctor_name }}</td>
                                    <td>{{ item.contactno }}</td>
                                    <td>
                                        <span >{{ item.student_count }}</span>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="padding-top:20px"><div>
                                        <v-autocomplete :items="instructor_list" v-model="item.selected_id" item-value="ins_id" item-text="ins_emp_code_name" dense placeholder="Select Instructor" outlined />
                                        </div>
                                        <div>
                                            <v-btn small class="button ml-3" @click="addProctorData(item)">Change</v-btn>
                                        </div>
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
    </v-card>
  </div>
</template>
<script>
import "@/assets/css/color.css";
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      loader: false,
      dates: [],
      exam: "",
      proctor: "",
      date: "",
      snackbar_msg: "",
      snackbar: false,
      color: "",
      slotNo: "",
      startTime: "",
      endTime: "",
      search: "",
      proclist: false,
      exam_list: [],
      slot_list: [],
      exam_proctor_session_list: [],
      instructor_list: [],
      proctor_list: [],
      deleteItem: {
        delete_id: "",
      },
      allData: [],
      id: "",
      proctor:null,
      dialog_delete: false,
      check: "",
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
      this.loader = true;
      axios
        .post("/ProctorDutyAppoinment/getproctorappointmentdeatilsChange")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.exam_list = res.data.exam_list;
            this.exam_proctor_session_list = res.data.exam_proctor_session_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          console.log("error", error);
        })
        .finally(() => {
          this.loader = false;
        });
    },
                fetchdetails() {
                let newDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                if (this.exam == "") {
                    this.showSnackbar("#b71c1c", "Please Select Exam.!");
                    return;
                }
                if (this.slotNo == "") {
                    this.showSnackbar("#b71c1c", "Please Select Slot No.!");
                    return;
                }
                const data = {
                    slot: this.slotNo,
                    exam: this.exam,
                    date: newDate,
                };
                console.log("data" + data.slot + " " + data.exam + " " + data.date);
                axios
                    .post("/COE/fetchProctorDetailsForChange", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                          this.instructor_list = res.data.instructor_list
                            if (res.data.proctor_list == "") {
                                this.showSnackbar("#b71c1c", "No Data found!");
                            } else {
                                this.proctor_list = res.data.proctor_list;
                            }
                        } else {
                            // alert("in else")
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        // alert("in catch")
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            addProctorData(item) {
                let formatDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");
                if (item.selected_id == "") {
                    this.showSnackbar("#b71c1c", "Please Select Proctor/Instructor.!!!");
                    return;
                }
                const data = {
                    slot: this.slotNo,
                    exam: this.exam,
                    date: formatDate,
                    proctor: item.selected_id,
                    proctor_id:item.proctor_id,

                };
                axios
                    .post("/ProctorDutyAppoinment/addProctorChange", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.showSnackbar("success", "Proctor change successfully");
                            this.fetchdetails();
                            this.onLoad();
                            this.proctor = "";
                        }
                        if (res.data.status.code == "NA") {
                            this.showSnackbar("error", "Proctor Alredy Exist!!");
                            this.proctor = "";
                        }
                    })
                    // .catch((error) => {
                    //     console.log("error", error);
                    //     this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    // })
                    .finally(() => {});
            },
    findSlot() {
      let formatDate = moment(this.date, "DD-MM-YYYY").format("YYYY-MM-DD");

      const data = {
        examId: this.exam,
        date: formatDate,
      };
      axios
        .post("/ProctorDutyAppoinment/getSlot", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.slot_list = res.data.slot;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    findDates() {
      const data = {
        examId: this.exam,
      };
      axios
        .post("/ProctorDutyAppoinment/getExamDate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.dates = res.data.dates;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    findtime() {
      const data = {
        slot: this.slotNo,
      };
      axios
        .post("/ProctorDutyAppoinment/getslottime", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.endTime = res.data.end_time;
            this.startTime = res.data.start_time;
          } else {
            // alert("in else")
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          // alert("in catch")
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    proctorList(item) {
      this.proclist = true;
      console.log("item", item.examdata);
      axios
        .post("/ProctorDutyAppoinment/proctorData", item.examdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.proctordata = res.data.proctordata;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
  },
};
</script>
<style scoped>
.table-name {
  color: hsla(190, 99%, 30%, 1);
  font-weight: bold;
  text-align: center;
}
.delete-popup {
  text-align: center;
  border: 4px solid red;
  /* margin: 1rem; */
  padding: 1rem;
  border-radius: 15px;
}
.flex {
  display: flex;
  justify-content: center;
  margin: 0px;
}
.flex-right {
  display: flex;
  justify-content: flex-end;
}
.box {
  background-color: #add8e630;
  margin: 8px;
  padding: 8px;
}
.select >>> .v-input__slot {
  background: white !important;
  border-color: hsla(190, 99%, 30%, 1) !important;
}
.date >>> .v-input__slot {
  background: white !important;
  border-color: hsla(190, 99%, 30%, 1) !important;
}
.a-proctor {
  border: 3px solid hsla(190, 99%, 30%, 1);
  border-radius: 15px;
}
.mytable /deep/ thead th {
  background-color: hsla(190, 99%, 30%, 1) !important;
  color: white !important;
  white-space: nowrap !important;
}
.box-import {
  border: 2px solid hsla(190, 99%, 30%, 1);
  margin: 1rem;
  padding: 1.1rem;
}
</style>
